'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = decodeJwtToken;
/**
 * This function exactly copied from keycloak-js version 2.2.1
 *
 * @param str - encoded JWT token
 * @returns {Object} decoded JWT token
 */
function decodeJwtToken(str) {
    if (!str) {
        return null;
    }

    var res = void 0;
    res = str.split('.')[1];

    res = res.replace('/-/g', '+');
    res = res.replace('/_/g', '/');
    switch (res.length % 4) {
        case 0:
            break;
        case 2:
            res += '==';
            break;
        case 3:
            res += '=';
            break;
        default:
            throw new Error('Invalid token');
    }

    res = (res + '===').slice(0, res.length + res.length % 4);
    res = res.replace(/-/g, '+').replace(/_/g, '/');

    res = decodeURIComponent(escape(atob(res)));

    res = JSON.parse(res);
    return res;
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/dist/authorization/decodeJwtToken.js
// module id = 713
// module chunks = 118